import React from "react";
import { IMAGES } from "../data/site";
import { Link } from "react-router-dom";
import PageHero from "../components/dental/PageHero";
import SectionTitle from "../components/dental/SectionTitle";
import Button from "../components/dental/Button";
import {
  Sparkles,
  Heart,
  Award,
  Leaf,
  Headphones,
  Wind,
  Coffee,
  Zap,
} from "lucide-react";
import { siteInfo } from "../mock";
import { doctorBio } from "../data/site";
import { Check } from "lucide-react";
import DentalServices from "../components/dental/DentalServices";
import OfficeGallery from "../components/dental/OfficeGallery";
import { openWeaveBookingInNewTab, WEAVE_BOOKING_URL } from "../lib/weaveBooking";

const features = [
  {
    icon: Wind,
    title: "Aromatherapy",
    desc: "Soothing scents to enhance your relaxation and healing experience.",
  },
  {
    icon: Zap,
    title: "Dental Chair Massage",
    desc: "Therapeutic massage during your visit for ultimate comfort and wellness.",
  },
  {
    icon: Headphones,
    title: "Noise Canceling Audio",
    desc: "Enjoy your choice of music or Netflix with premium noise-canceling headphones.",
  },
  {
    icon: Coffee,
    title: "Organic Herbal Teas",
    desc: "Complimentary premium coffee and organic herbal teas to enjoy during your visit.",
  },
];

const OurPractice = () => (
  <>
    <PageHero
      subtitle="Welcome to"
      title="Our Practice"
      breadcrumb="Our Practice"
      image={IMAGES.ed4}
      // image="https://images.unsplash.com/photo-1629909613654-28e377c37b09"
    />

    <OfficeGallery />

    {/* Our Mission Section */}
    <section className="bg-[#FBF8F1] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="font-cinzel text-4xl md:text-5xl gold-gradient-text mb-8">
            Our Mission
          </h2>
          <div className="space-y-4 text-[#4E5750]/90 leading-relaxed text-base">
            <p>
              At Galleria Dental, our mission is rooted in Dr. K's philosophy that dentistry is about much more than treating teeth. It is about caring for the person behind the smile and using our knowledge, experience, and compassion to make a meaningful difference in that person's life.
            </p>
            <p>
              Our goal is to improve the lives of every patient we care for, young, old, and every age in between. Whether someone comes to us to maintain a healthy smile, relieve pain, restore function, overcome years of dental concerns, or simply feel more confident about the way they look, we believe every patient deserves the same level of respect, attention, and commitment to their well-being.
            </p>
            <p>
              As part of the Smiles by Dr. K family, we strive to provide the highest quality dental, esthetic, and therapeutic care in an environment where patients feel welcome, comfortable, understood, and genuinely cared for.
            </p>
            <p>
              For Dr. K, a beautiful smile is not simply the result of great dentistry, it is part of helping people feel healthier, happier, and better about themselves and their lives.
            </p>
          </div>
        </div>
        <div className="relative">
          <div className="absolute -top-4 -right-4 w-24 h-24 border border-[#B79A68]/60 z-0" />
          <img
            src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/0bfe5390-5b9a-4391-afd3-244b88de393f.jpg"
            alt="Our Mission"
            className="relative w-full h-full object-cover z-10"
          />
          <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-[#B79A68]/60 z-0" />
        </div>
      </div>
    </section>

    <section className="bg-[#FBF8F1] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-28 h-28 border border-[#B79A68]/50 z-0" />
            <img
              src={doctorBio.image}
              alt={doctorBio.name}
              className="relative w-full h-[520px] object-cover z-10"
            />
            <div className="absolute -bottom-4 -right-4 w-28 h-28 border border-[#B79A68]/50 z-0" />
          </div>
        </div>
        <div className="md:col-span-3">
          <SectionTitle
            script=""
            title="Our Doctor"
            subtitle={doctorBio.name}
            align="left"
          />

          {/* <p className="font-script text-4xl md:text-5xl gold-gradient-text leading-none p-2">
            {doctorBio.name}
          </p> */}

          {/* <p className="text-[#7D6A42] uppercase tracking-[0.3em] text-[11px] mt-3 font-cinzel">
            {doctorBio.title}
          </p>
          <div className="w-16 h-px bg-[#B79A68] my-6" /> */}
          <div className=" my-6" />
          <p className="text-[#4E5750] text-lg leading-relaxed mb-5">
            {doctorBio.intro}
          </p>
          {doctorBio.paragraphs.map((p, i) => (
            <p key={i} className="text-[#4E5750]/85 leading-relaxed mb-4">
              {p}
            </p>
          ))}
          <div className="mt-8">
            <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.2em] mb-4">
              Credentials & Affiliations
            </h3>
            <ul className="space-y-3">
              {doctorBio.credentials.map((c) => (
                <li
                  key={c}
                  className="flex items-start gap-3 text-[#4E5750]/85"
                >
                  <span className="shrink-0 w-5 h-5 rounded-full border border-[#B79A68] flex items-center justify-center mt-0.5">
                    <Check size={11} className="text-[#7D6A42]" />
                  </span>
                  {c}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-9 flex gap-3 flex-wrap">
            <Button href={WEAVE_BOOKING_URL} onClick={openWeaveBookingInNewTab}>Book A Consult</Button>
            <Button to="/smile-gallery" variant="outline">
              See Smile Gallery
            </Button>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-[#FBF8F1] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="absolute -top-4 -left-4 w-24 h-24 border border-[#B79A68]/60 z-0" />
          <div className="relative z-10 grid grid-cols-2 grid-rows-2 gap-3 h-[460px]">
            <img
              src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/42513e84-b9b1-4a78-847b-f23ef6eb5454.png"
              alt="iTero Lumina intraoral scanner"
              className="col-span-2 w-full h-full object-cover"
            />
            <img
              src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/c479d5f9-023e-46ac-a543-1184417c5143.jpg"
              alt="Digital dental scanning technology"
              className="w-full h-full object-cover"
            />
            <img
              src="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/48c87ca3-9dca-4c3f-941b-26aaf27c272c.png"
              alt="iTero Lumina digital smile scan"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border border-[#B79A68]/60 z-0" />
        </div>
        <div>
          <SectionTitle
            script=""
            title="Our Technology"
            subtitle="iTero Lumina™ Intraoral Scanner"
            align="left"
          />
          <div className="mt-6 space-y-4 text-[#4E5750]/90 leading-relaxed">
            <p>
              At Galleria Dental, we use the advanced iTero
              Lumina™ intraoral scanner to create highly detailed,
              photorealistic 3D images of your teeth and smile.
            </p>
            <p>
              With its smaller scanning wand and advanced imaging technology,
              iTero Lumina provides a fast, comfortable alternative to
              traditional impressions while allowing us to capture detailed
              digital models of your teeth and bite.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.2em] mb-4">
              What iTero Lumina Means for You
            </h3>
            <ul className="space-y-3">
              {[
                "No messy traditional impressions for many procedures",
                "Fast, comfortable digital scanning",
                "Highly detailed 3D visualization",
                "Photorealistic images that let you see what we see",
                "Digital planning for Invisalign®",
                "Support for crowns, bridges and restorative treatment",
                "Ability to monitor changes in your teeth over time",
                "Easier conversations about your treatment and expected results",
              ].map((point) => (
                <li
                  key={point}
                  className="flex items-start gap-3 text-[#4E5750]/85"
                >
                  <span className="shrink-0 w-5 h-5 rounded-full border border-[#B79A68] flex items-center justify-center mt-0.5">
                    <Check size={11} className="text-[#7D6A42]" />
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.2em] mb-4">
              See Your Smile Differently
            </h3>
            <div className="space-y-4 text-[#4E5750]/90 leading-relaxed">
              <p>
                Your scan appears on screen as an interactive 3D model, allowing
                you and your dentist to examine your teeth from different angles
                and discuss treatment options together.
              </p>
              <p className="font-cinzel text-[#7D6A42] tracking-[0.05em]">
                Comfortable. Digital. Precise.
              </p>
              <p>
                iTero Lumina brings advanced digital imaging directly into your
                dental visit, helping make treatment planning more visual,
                efficient and easier to understand.
              </p>
            </div>
          </div>

          <div className="mt-8 flex gap-3">
            {/* <Button to="/meet-the-doctor">About Doctor</Button> */}
            {/* <Button to="/contact" variant="outline">Book a Consult</Button> */}
          </div>
        </div>
      </div>
    </section>
    <DentalServices />

    {/* <section className="bg-[#ffffff] py-20 border-t border-[#B79A68]/15">
      <div className="max-w-7xl mx-auto px-6">
        <SectionTitle
          script="What Makes Us"
          title="Different"
          subtitle="The Galleria Dental Difference"
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {features.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="relative bg-[#ffffff] p-7 text-center border border-[#B79A68]/30 hover:border-[#B79A68] transition-colors"
            >
              <div className="w-14 h-14 rounded-full border border-[#B79A68] flex items-center justify-center mx-auto mb-4 text-[#7D6A42]">
                <Icon size={22} />
              </div>
              <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.15em] mb-3">
                {title}
              </h3>
              <p className="text-[#4E5750]/80 text-sm leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section> */}

    <section className="bg-[#ffffff] py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <SectionTitle
          script="Ready For"
          title="Your Visit"
          subtitle="Start Today"
        />
        <p className="text-[#4E5750]/80 leading-relaxed mt-6">
          Whether you are joining us for a smile makeover, an Invisalign consult
          or simply a wellness facial, we cannot wait to welcome you. Reserve
          your time below.
        </p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Button to="/contact">Contact Us</Button>
          {/* <Link to="/smile-gallery" className="text-[#7D6A42] hover:text-[#5F4F30] font-cinzel uppercase text-[12px] tracking-[0.3em] py-3">
            View Smile Gallery →
          </Link> */}
        </div>
      </div>
    </section>
  </>
);

export default OurPractice;
